import type { Event } from '@schema/event'
import type {
  ExistingImage,
  ImagePreview,
} from '@app/components/blocks/imageEditRow/ImageEditRow'

export type EventWithId = Event & { id: number }

export type EventType = 'group' | '1on1'
export type LocationType = 'offline' | 'online'
export type Visibility = 'members' | 'members_followers' | 'public'

export const visibilityToApiArray = (
  v: Visibility,
): ('members' | 'followers' | 'public')[] => {
  switch (v) {
    case 'members':
      return ['members']
    case 'members_followers':
      return ['members', 'followers']
    case 'public':
      return ['public']
  }
}

export const apiArrayToVisibility = (
  arr: ('members' | 'followers' | 'public')[],
): Visibility => {
  if (arr.includes('public')) return 'public'
  if (arr.includes('members') && arr.includes('followers'))
    return 'members_followers'
  if (arr.includes('members')) return 'members'
  return 'members'
}


export type GeneralInfoFormValues = {
  title: string
  intro?: string
  content: string
  isGroupEvent: boolean
  start: string
  end?: string
}

export type LocationCoverFormValues = {
  address: string
  meetingLink: string
  geo?: { lat: number; long: number }
}

export type EventSettingsFormValues = {
  limit?: number
  enableWaitlist: boolean
  visibility: Visibility
  reminder: boolean
}

export type CollectedEventData = {
  eventType: EventType
  locationType: LocationType
  generalInfo: GeneralInfoFormValues | null
  locationCover: LocationCoverFormValues | null
  eventSettings: EventSettingsFormValues | null
  coverImages: ImagePreview[]
  existingImages?: ExistingImage[]
}
